import React from 'react';
import styled from 'styled-components';
import MicroProfile from '../../micro-profiles/micro-profile';

const Container = styled.article`
  > .micro-profile {
    hr[class^="author__Divider"] {
      display: none;
    }

    p.micro-profile-organization {
      color: ${props => props.theme.bodyColor};
    }
  }
`;

export default function Profile(props) {
  return (
    <Container>
      <MicroProfile {...{ ...props, isOnContributorSearchResultPage: true }} />
    </Container>
  );
}
